import React, { useEffect, useState } from "react";
import TextButtonView from "presentational/common/TextButtonView";
import TXT from "presentational/common/multinational/TXT";
import config from "lib/fr-config";
import { getDeviceType } from "lib/deviceInfo";
import PropTypes from "prop-types";

const MY_TAB_BAR = [
  {
    type: "mylist",
    selected: ["mylist", "favorites"],
    label: <TXT name="btnTab_outfits" />
  },
  {
    type: "myitem",
    selected: ["myitem"],
    label: <TXT name="btnTab_items" />
  },
  {
    type: "bookmarked",
    selected: ["bookmarked"],
    label: <TXT name="btnTab_bookmarked" />
  }
];

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;

const cssXL = {
  root: {
    marginBottom: desktopCss.standardPaddingBetweenContent,
    display: "flex",
    justifyContent: "flex-end"
  }
};
const cssXS = {
  root: {
    marginBottom: mobileCss.standardPaddingBetweenContent,
    display: "flex",
    justifyContent: "flex-end",
    flexWrap: "wrap"
  }
};

CommonPortfolioTabBarView.propTypes = {
  tabBarType: PropTypes.oneOf(["myTabBar"]).isRequired,
  value: PropTypes.oneOf(["mylist", "favorites", "bookmarked", "myitem"])
    .isRequired,
  onTabBtnClick: PropTypes.func.isRequired
};

function CommonPortfolioTabBarView(props) {
  const { tabBarType, value, onTabBtnClick } = props;
  const [tabBarList, setTabBarList] = useState([]);

  useEffect(() => {
    init();
  }, [tabBarType]);

  const css = getDeviceType() === "mobile" ? cssXS : cssXL;

  const init = () => {
    switch (tabBarType) {
      case "myTabBar":
        setTabBarList(MY_TAB_BAR);
        break;
      default:
        setTabBarList([]);
        break;
    }
  };

  const getNormalTabButton = ({ unit, value, isLastBtn }) => {
    const { type, selected, label } = unit;

    return (
      <TextButtonView
        key={type}
        design={selected.includes(value) ? "select" : "unselect"}
        onClick={onTabBtnClick(type)}
        disableRightMargin={isLastBtn}
      >
        {label}
      </TextButtonView>
    );
  };

  // const getDropdownButton = () => {
  //   /*
  //    * 하단은 예전 탭버튼이 4개이상일때 3번째 버튼부터 드랍다운으로 숨기던 방식
  //    * 재사용 가능성 있어서 냅둠
  //    * */
  //   /* <DropdownButtonView
  //       disableRightMargin
  //       dropdownName={"otherTab"}
  //       menuList={[
  //         {
  //           value: "bookmarked",
  //           text: <TXT name="btnTab_bookmarked" />
  //         },
  //         {
  //           value: "poll_request",
  //           text: <TXT name="btnTab_polls" />
  //         }
  //       ]}
  //       onSelect={handleDropdownSelect}
  //       selectedItem={getSelectedItem()}
  //       initialText={<TXT name="btnTab_others" />}
  //     /> */

  //   return null;
  // };

  return (
    <div style={css.root}>
      {tabBarList.map((unit, index) =>
        getNormalTabButton({
          unit,
          value,
          isLastBtn: tabBarList.length - 1 === index
        })
      )}
    </div>
  );
}

export default CommonPortfolioTabBarView;
